import React from 'react';
import SSO_Redirection from 'app/redirection-SSO';
import CRMflows_Redirection from 'app/redirection-CRMflows';
import { UilExchange } from '@iconscout/react-unicons';
import './redirectComp.scss';
import PopMenu, { PopMenuItem } from './popmenu';
import Tracker from 'app/tracking/tracking-service';
import { Enums } from 'services/dropdown-enums';
import { getNewRefreshToken } from 'store/slices/auth/authSlice';
import storage from 'services/utils/storage';
import { getCookie } from 'services/utils/generic.methods';

const RedirectComp = ({ showSideBar, switchTo }) => {
  const redirectHandler = () => {
    // call Tracker event for switchTo
    Tracker.EventsProvider(
      Enums.TrackerType.GoogleAnalytics
    ).Redirection.SwitchToLegacyPortal();

    // redirection here..
    SSO_Redirection();
  };

  const crmFlowsRedirectHandler = async () => {
    let newProfile = {};
    const profile = JSON.parse(storage.getItem('Profile'));
    const alreadyLoggedIn = getCookie('CRM-Auth');
    const crmCompany = getCookie('companyKey');
    // Skip fetching new token in case user is already logged in to CRM flows with same company
    if (!(alreadyLoggedIn && crmCompany && crmCompany === profile.CompanyKey)) {
      const token = await getNewRefreshToken({
        token: profile.RefreshToken,
        companyKey: profile.CompanyKey
      });
      if (token) {
        newProfile = { profile: { ...profile, RefreshToken: token } };
        storage.setItem('Profile', newProfile.profile);
      }
    }
    CRMflows_Redirection(newProfile);
  };

  return (
    <>
      <PopMenu
        id="introJS-item-switch"
        showSideBar={showSideBar}
        title={'Switch'}
        toolTipText={'Switch'}
        menuHeading={'Switch'}
        showTooltip={false}
        path={undefined}
        icon={<UilExchange size="24" className="sidebar-link" />}
      >
        {props => {
          return (
            <>
              {switchTo.allowPortal && (
                <PopMenuItem
                  text={`Legacy Portal`}
                  handler={() => {
                    props.menuSet(false);
                    redirectHandler();
                  }}
                  loading={false}
                />
              )}
              {/* {switchTo.allowCRM && (
                <PopMenuItem
                  text={`CRM flows`}
                  handler={() => {
                    props.menuSet(false);
                    crmFlowsRedirectHandler();
                  }}
                  loading={false}
                />
              )} */}
            </>
          );
        }}
      </PopMenu>
    </>
  );
};

export default RedirectComp;
